import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminReferralsPage from "@/pages/admin/AdminReferralsPage";

export const Route = createFileRoute("/_admin/admin/referrals")({
  head: () => pageHead("Admin · Referrals", "AKIVA admin · referrals portal.", "/admin/referrals", true),
  component: AdminReferralsPage,
});
